import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import "./v-button.component.scss";

export interface IVButtonDropDownItem<T = any> {
    id?: any;
    icon?: string;
    label: string;

    data?: T;

    disabled?: boolean;
}

@Component({
    selector: 'v-button',
    template: require('./v-button.component.html')
})
export class VButtonComponent implements AfterViewInit, OnChanges {
    @Input() icon: string;
    @Input() iconPosition: "left" | "right";
    @Input() hovered: boolean;

    @Input() contentAlign: "left" | "center" | "right" = "left";
    @Input() dropDownItems: IVButtonDropDownItem[];
    @Input() dropDownPosition: "bottom-left" | "top-right" = "bottom-left";
    @Input() showDropDown: boolean;
    @Input() showNextPrev: boolean;
    @Input() disableNext: boolean;
    @Input() disablePrev: boolean;
    @Input() disabled: boolean;
    @Input() @HostBinding("class.loading") loading: boolean;
    @Input() isDropdown: boolean;

    @Input() iconOnly: boolean;

    @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter();
    @Output() onNextClick: EventEmitter<any> = new EventEmitter();
    @Output() onPrevClick: EventEmitter<any> = new EventEmitter();
    @Output() onItemClick: EventEmitter<IVButtonDropDownItem> = new EventEmitter();

    // ---

    isFontAwesome = false;
    dropdownIsFontAwesome = false;
    usingCdkPortal = false;

    constructor(
        private readonly cd: ChangeDetectorRef,
        private readonly elementRef: ElementRef<HTMLElement>) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["showDropDown"] || changes["dropDownItems"]) {
            this.isDropdown = this.showDropDown || !!this.dropDownItems;
            this.dropdownIsFontAwesome = this.dropDownItems?.some(item => item.icon.indexOf("fa-") == 0);
        }

        if (changes["icon"]) {
            this.isFontAwesome = this.icon.indexOf("fa-") == 0;

            // Auto add fa-solid if not set
            if (this.isFontAwesome && this.icon.split("fa-").length == 2) {
                this.icon += " fa-solid";
            };
        }
    }

    ngAfterViewInit(): void {
        var button = this.elementRef.nativeElement.querySelector("button");
        var span = button.querySelector("span");

        if (typeof this.iconOnly == undefined && this.icon && !this.showNextPrev && span?.textContent == "") {

            this.iconOnly = true;
        }

        this.cd.detectChanges();
    }

    @HostListener('document:mousedown', ['$event'])
    onGlobalClick(event: MouseEvent): void {
        // If we are inside this element, then do nothing
        if (this.elementRef.nativeElement.contains(event.target as any)) {
            return;
        }

        if (this.usingCdkPortal) {
            var htmlElement = event.target as HTMLElement;
            if (!htmlElement.classList.contains("cdk-overlay-connected-position-bounding-box")) {
                return;
            }
        }

        // If we are outside the element then close drop down, if its open
        if (this.showDropDown) {
            this.showDropDown = false;
            event.cancelBubble = true;
            event.preventDefault();
        }
    }

    onButtonClicked($event: MouseEvent): void {
        this.onClick.emit($event);

        if (this.dropDownItems) {
            this.showDropDown = !this.showDropDown;
        }

        $event.preventDefault();
    }

    dropDownItemClicked(dropDownItem: IVButtonDropDownItem): void {
        this.onItemClick.emit(dropDownItem);
        this.showDropDown = false;
    }

    // ---

}

